/**
 * When the admin is viewing `/admin/users/:uid/settings/*`, every
 * callable used by Settings hooks must operate on the target user's
 * data — not the admin's own. The server-side helper
 * `resolveOperatingUid(request)` reads `request.data.uid` and verifies
 * admin status; on the client, every shared-Settings hook adds the
 * target uid into its callable payload via this tiny helper.
 *
 * Self-mode returns an empty object → the spread is a no-op and the
 * callable falls back to `request.auth.uid` server-side.
 */
import { useEffectiveUid, useIsAdminMode } from '../auth/TargetUidContext';

export function useTargetUidPayload(): { uid?: string } {
  const targetUid = useEffectiveUid();
  const adminMode = useIsAdminMode();
  if (adminMode && targetUid) return { uid: targetUid };
  return {};
}
